import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Loader2 } from "lucide-react";

export default function Customers() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/customers").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  if (items === null) return <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 text-sky-400 animate-spin" /></div>;

  return (
    <div data-testid="customers-view">
      <div className="tick-label text-sky-400 mb-2">/ Customer Lifetime</div>
      <h1 className="font-display font-black text-3xl text-slate-100 mb-6">Paying Customers</h1>

      {items.length === 0 ? (
        <div className="panel p-12 text-center text-slate-500 text-sm italic">No customers yet.</div>
      ) : (
        <div className="panel">
          <div className="grid grid-cols-12 gap-3 px-4 py-2.5 border-b border-[var(--border-soft)] tick-label">
            <div className="col-span-4">Email</div>
            <div className="col-span-1 text-right">Orders</div>
            <div className="col-span-2 text-right">Revenue</div>
            <div className="col-span-2 text-center">Tiers</div>
            <div className="col-span-3 text-right">First / Last Purchase</div>
          </div>
          {items.map((c) => (
            <div key={c.email} className="grid grid-cols-12 gap-3 px-4 py-3 border-b border-[var(--border-soft)] last:border-0">
              <div className="col-span-4 text-sm text-slate-100 font-mono">{c.email}</div>
              <div className="col-span-1 text-right metric-number text-sky-400">{c.purchases}</div>
              <div className="col-span-2 text-right metric-number text-emerald-400">${c.revenue.toLocaleString()}</div>
              <div className="col-span-2 text-center font-mono text-[10px] tracking-widest uppercase text-slate-400">{c.tiers.join(" · ")}</div>
              <div className="col-span-3 text-right font-mono text-[10px] text-slate-500">
                {(c.first_purchase_at || "").slice(0, 10)} → {(c.last_purchase_at || "").slice(0, 10)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
